import classNames from "classnames";

import type {ISearchComboboxDividerProps} from "../types/ISearchComboboxDividerProps";

import * as styles from "./SearchComboboxDivider.module.css";

/** 1px line between groups, edge to edge of the panel. */
export const SearchComboboxDivider = (props: ISearchComboboxDividerProps) => (
    <div role="presentation" className={classNames(styles.divider, props.className)} />
);
import classNames from "classnames";

import type {ISearchComboboxDividerProps} from "../types/ISearchComboboxDividerProps";

import * as styles from "./SearchComboboxDivider.module.css";

/** 1px line between groups, edge to edge of the panel. */
export const SearchComboboxDivider = (props: ISearchComboboxDividerProps) => (
    <div role="presentation" className={classNames(styles.divider, props.className)} />
);
